<template>
  <div>
    <van-field readonly clickable :value="value" @click="showPicker = true" />
    <van-popup v-model="showPicker" position="bottom">
      <van-picker show-toolbar :columns="columns" :default-index="defaultindex" @cancel="showPicker = false" @confirm="onConfirm" />
    </van-popup>
    <van-field v-model="input" :placeholder="'请输入' + value" />
  </div>
</template>
<script>
export default {
  props: ["coluMns", "defaultIndex", "Value"],
  data () {
    return {
      columns: this.coluMns,
      showPicker: false,
      defaultindex: this.defaultIndex,
      //选择类型
      value: this.Value,
      //输入内容
      input: ""
    };
  },
  methods: {
    onConfirm (value) {
      this.value = value;
      this.showPicker = false;
    }
  }
};
</script>
<style lang="less"></style>
